export { default } from "./ScrollToHorizontal";
